import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken, clearToken } from '../utils/storage';
import { decodeJwtPayload } from '../utils/jwt';

const isTokenExpired = (token) => {
    const payload = decodeJwtPayload(token);
    return !payload || payload.exp * 1000 < Date.now();
};

const ProtectedRoute = ({ children }) => {
    const token = getToken();
    const location = useLocation();

    if (!token || isTokenExpired(token)) {
        clearToken();
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;
